import React from 'react';
import { motion } from 'framer-motion';
export function WhatAreThey() {
  return <section className="py-12 sm:py-16 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto text-center pt-[0px] pb-[0px] pl-[16px] pr-[16px]" data-id="element-252">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} data-id="element-253">
        <h2 className="text-3xl sm:text-4xl text-deco-text mb-6 font-bold leading-tight" data-id="element-254">
          ¿Qué son las Flores Eternas?
        </h2>
        <p className="text-base sm:text-lg text-deco-taupe font-medium mb-10 leading-relaxed" data-id="element-255">
          Son flores decorativas hechas con <strong data-id="element-256">limpiapipas</strong>, un
          material flexible, económico y fácil de conseguir.
        </p>
      </motion.div>
    </section>;
}